<form [formGroup]="grupoForm" id="grupoForm">
  <div class="row row-cols-1">
    <div class="col form-group my-2">
      <label class="form-label">Escolha as opções</label>
      <div class="col-12">
        <nz-select formControlName="grupos" nzPlaceHolder="-" nzSize="large" nzShowSearch
          [nzShowArrow]="false" [nzFilterOption]="nzFilterOption" nzSize="large" [nzAllowClear]="true" nzMode="multiple" [compareWith]="compareFn">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeGrupo" *ngFor="let item of opcoesGrupos" />
        </nz-select>
      </div>
    </div>
  </div>
</form>
